import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-secondary-50">
      <div className="container px-4 py-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md mx-auto"
        >
          <h1 className="mb-4 text-9xl font-bold text-primary-600">404</h1>
          <h2 className="mb-6 text-3xl font-bold text-secondary-800">Page Not Found</h2>
          <p className="mb-8 text-lg text-secondary-600">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 text-white transition-colors rounded-md bg-primary-600 hover:bg-primary-700"
          >
            Back to Homepage
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
